import { render, staticRenderFns } from "./ShowFractions.vue?vue&type=template&id=7dffaff9"
import script from "./ShowFractions.vue?vue&type=script&lang=js"
export * from "./ShowFractions.vue?vue&type=script&lang=js"
import style0 from "./ShowFractions.vue?vue&type=style&index=0&id=7dffaff9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports